export default {
  proXtraSpend: {
    currentYearSpend: '0.00',
    currentYearLastUpdatedDate: '2022',
    programTypCd: null,
    isRebateProgram: null,
    previousYearSpend: '0.00',
    previousYearUpdatedDate: '2021',
    currentYearSavings: '0.00',
    previousYearSavings: '0.00',
    totalCurrentYearSpend: '0',
    totalCurrentYearSavings: '0',
    totalPreviousYearSpend: '0',
    totalPreviousYearSavings: '0'
  },
  perkSummary: {
    unclaimedPerksCount: 0,
    activePerksCount: true,
    availableActiveOffers: true,
    activeSurpriseDelightCount: 0,
    currentYearPerksProgramSpend: '800100.00',
    perksProgramId: '4690',
    amtReqToNextLevel: '99900.01',
    activePxccFactor: 4,
    perkCurrentTierProgressPercentage: '0',
    pxccUserCategory: 'Unenrolled',
    accrualData: [
      {
        year: 2022,
        currentYear: true,
        accrual: 800100,
        acceleratedAccrual: 800100,
        pxccAccrual: 0,
        pxccAcceleratedAccrual: 0,
        nonPxccAccrual: 800100,
        spendForNextPerk: 99900,
        spendForNextPerkWithPxcc: 24975,
        spendForFutureTierPerk: 199900,
        spendForFutureTierPerkWithPxcc: 49975,
        finalTierPerkAchieved: true
      }
    ]
  },
  userProfile: {
    name: {
      firstName: 'Test',
      lastName: 'Test',
      nickName: null
    },
    role: 'ADMIN',
    localStoreId: '0121',
    shipToAddress: {
      postalDetails: {
        addressLine1: 'Test',
        city: 'Atlanta',
        state: 'GA',
        zipCode: '30339'
      }
    }
  },
  customerInfo: {
    companyName: 'TEST',
    accountNumber: '2493283742',
    memberSince: '2021',
    managedAccount: false,
    nationalAccount: false,
    segment: '',
    enrolledInPerksProgram: true,
    enrolledInPreferredPricing: false,
    preferredPricingTierZero: false,
    preferredPricingTierZeroMaxThreshold: null,
    hierarchyOrgId: null,
    isRecentlyEnrolledInPerksProgram: false,
    isRecentlyEnrolledInPrefPricing: false,
    nationalAccountDetails: null,
    displayOldPlumbingExperience: false,
    preferredPricingPgmsUnlocked: 0,
    enrolledInMilitaryProgram: false,
    isMilitaryDiscountCapped: false,
    paintMembershipLevel: 'Gold'
  }
};